/**
 * @deprecated Use withCardSelected by card-selected.hocs.ts
 */

const mapCardModalSelectedToProps = state => ({
    cardModalSelected: state.cards.cardSelected.data,
});

export default mapCardModalSelectedToProps;
